import ifHasPermissionDirective from './if-has-permission';

const directives = {
  ifHasPermission: ifHasPermissionDirective,
};


const VueCustomDirectives = {
  install(Vue) {
    Object.keys(directives).forEach(name => {
      Vue.directive(name, directives[name]);
    });
  },
};

export default VueCustomDirectives;
